/**
 * Initializes the accordion functionality.
 * @param {string} selector - The CSS selector for the accordion elements.
 */
var intervalID = false;
const accordion = (selector) => {
  /**
   * Closes all of the linked images
   * @param {Event} event - The click event.
   */
  const hideAllImages = () => {
    document.querySelectorAll("figure[data-img]").forEach((img) => {
      img.classList.remove("active");
    });
  };

  /**
   * Closes all open accordion details except the clicked one.
   * @param {Event} event - The click event.
   */
  const closeOpenDetails = (event) => {
    var allDetails = event.currentTarget.parentNode.querySelectorAll("details");
    allDetails.forEach((detail) => {
      detail.nextElementSibling.style.maxHeight = null;
      if (detail.hasAttribute("open")) detail.classList.remove("active");
      if (detail !== event.currentTarget) detail.removeAttribute("open");
    });
  };

  /**
   * Initializes the accordion functionality for a single accordion element.
   * @param {HTMLElement} accWrapper - The accordion wrapper element.
   */
  const initAccordionElement = (accWrapper) => {
    var firstActive = document.querySelector("details + .content.active");
    firstActive.style.maxHeight = firstActive.scrollHeight + "px";

    const details = accWrapper?.querySelectorAll("details");
    details.forEach((detailTarget) => {
      detailTarget.addEventListener("click", (e) => {
        if (intervalID) clearInterval(intervalID);
        var wasAlreadyOpen = e.currentTarget.hasAttribute("open");
        closeOpenDetails(e);
        hideAllImages(e);
        if (!wasAlreadyOpen) {
          var nextSibling = e.currentTarget.nextElementSibling;
          nextSibling.classList.toggle("active");
          e.currentTarget.classList.toggle("active");
          nextSibling.style.maxHeight = e.currentTarget.nextElementSibling.scrollHeight + "px";
          document.querySelector('[data-img="' + e.currentTarget.dataset.imgLink + '"]').classList.add("active");
        }
      });
    });
  };

  function autoplayAccordions() {
    intervalID = window.setInterval(() => {
      var activeAccordion = document.querySelector("details + .content.active");
      if (!activeAccordion) return;
      activeAccordion.style.maxHeight = "0px";
      activeAccordion.classList.remove("active");
      var nextAccordion = activeAccordion.nextElementSibling?.nextElementSibling?.classList.contains("content") ? activeAccordion.nextElementSibling.nextElementSibling : document.querySelector("details + .content");
      if (!nextAccordion) return;
      nextAccordion.classList.add("active");
      nextAccordion.style.maxHeight = nextAccordion.scrollHeight + "px";
    }, 5000);
  }

  /**
   * Initializes the accordion functionality for a single accordion element.
   * @param {HTMLElement} accWrapper - The accordion wrapper element.
   */

  const accordionElements = document.querySelectorAll(selector);
  accordionElements?.forEach(initAccordionElement);
  //autoplayAccordions();
};

export default accordion;
